import React, { useState, useEffect } from "react";
import { Button, Grid } from "@mui/material";
import person from '../Icons/person.svg';
import dots from '../Icons/dots.svg';
import like from '../Icons/like.svg';
import comment from '../Icons/comment.svg';
import repost from '../Icons/re-post.svg';
import share from '../Icons/share.svg';
import { Link } from "react-router-dom";
import EditPost from "../components/EditPost";
import {HiOutlineUserCircle} from'react-icons/hi2';
import api, { noauthinstance } from '../utils/api';
import { CircularProgress } from "@mui/material"
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
function Feeds() {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [visibleItemCount, setVisibleItemCount] = useState(3);
    const [editingPostId, setEditingPostId] = useState(null);

    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        try {
            const response = await api.get("posts")
            setData(response.data);
            console.log('hhhhh',data)
            setLoading(false);
        } catch (err) {
            console.error('Error fetching data:', err);
            setError(err);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData()
    }, []);

    const handleClickEdit = (postId) => {
        setEditingPostId(postId);
    };

    const handleCancelEdit = () => {
        setEditingPostId(null);
    };
    const handleDelete = async (itemId) => {
        try {
            await api.delete(`posts/${itemId}`);
    
            fetchData();
            toast.success("Post deleted successfully!");
        } catch (error) {
            console.error('Error deleting item:', error);
            toast.error("An error occurred while deleting the post.");
        }
    }

    return (
        <>
            <div className="app-page-home">
                <Grid container spacing={2}>
                    <Grid item xs="12">
                        <div className="app-component-reportcard">
                            <div className="app-new-feeds">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} lg={12}>
                                        <div className="new-feeds-content">
                                            <div className="feeds-top-content">
                                                <h4>Feeds</h4>
                                            </div>
                                            <div className="add-post">
                                                <Link to="/Dashboard/createpost">
                                                    <Button>Create Post</Button>
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="mainfeeds-scroll">
                                        {loading && <CircularProgress />} {/* Show circular progress while loading */}
                                            {error && <div>Error fetching data. Please try again later.</div>}
                                            {!loading && !error && data && data.map((item, index) => (
                                            <div className="app-new-feeds-content-box" key={item.id}>
                                                {editingPostId === item.id ? (
                                                    <EditPost post={item} onCancelEdit={handleCancelEdit} />
                                                ) : (
                                                    <div>
                                                        {/* Render other content */}
                                                        <div className="person-info">
                                                            <div class="person-inf0-deatils">
                                                                <ul className="person-info-display">
                                                                    <li>
                                                                        <HiOutlineUserCircle/>
                                                                    </li>
                                                                    <li>{item.user?.first_name}    {item.user?.last_name}
                                                                        <span>
                                                                            <h5>MLA</h5>
                                                                            <h6>BRS</h6>
                                                                        </span>
                                                                    </li>
                                                                </ul>
                                                                <div class="person-info-content">
                                                                    <h4>{item.title}</h4>
                                                                    <p>{item.description}</p>
                                                                    <p>{item.address}{new Date(item.updatedAt).toDateString()}</p>
                                                                </div>
                                                            </div>

                                                            <ul className="menu-dots">
                                                                <li>
                                                                    <div className="dropdown">
                                                                        <button className="dropbtn">
                                                                            <img src={dots} alt="dots" />
                                                                        </button>
                                                                        <div className="dropdown-content">
                                                                            <a><Button onClick={() => handleClickEdit(item.id)}>Edit</Button></a>
                                                                            <a><Button onClick={() => handleDelete(item.id)}>Delete</Button></a>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div class="post-image">
                                                            <img src={item.image} />
                                                            {/* <div class="post-image-buttons">
                                                                <div class="post-buttons-1">
                                                                    <ul>
                                                                        <li>
                                                                            <img src={like} />
                                                                            <span>{item.like}Like</span>
                                                                        </li>
                                                                        <li>
                                                                            <img src={comment} />
                                                                            <span>Comments</span>
                                                                        </li>
                                                                        <li>
                                                                            <img src={repost} />
                                                                            <span>Repost</span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div class="post-image-buttons-2">
                                                                <ul>
                                                                    <li>
                                                                        <img src={share} />
                                                                        <span>Share</span>
                                                                    </li>
                                                                </ul>
                                                            </div> */}
                                                        </div>

                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                        </div>
                                    </Grid>
                                    {/* <Grid item xs={6} lg={6}>
                                        <Opinion />
                                    </Grid> */}
                                </Grid>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
            <ToastContainer />
        </>
    );
}

export default Feeds;





